// src/pages/Register.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { Eye, EyeOff } from "lucide-react"; // Eye icons for show/hide functionality
import BASE_URL from "../config";
const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [name, setName] = useState("");
  const [username, setUserName] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Register";
    // jQuery validation on form submit
    $(document).ready(() => {
      $("#registerForm").on("submit", function (e) {
        e.preventDefault();
        let isValid = true;

        // Validate Name
        if (!username) {
          $("#nameError").text("Full name is required");
          isValid = false;
        } else {
          $("#nameError").text("");
        }

        // Validate Email
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
          $("#emailError").text("Email is required");
          isValid = false;
        } else if (!emailPattern.test(email)) {
          $("#emailError").text("Enter a valid email");
          isValid = false;
        } else {
          $("#emailError").text("");
        }

        // Validate Password
        if (!password) {
          $("#passwordError").text("Password is required");
          isValid = false;
        } else if (password.length < 6) {
          $("#passwordError").text("Password must be at least 6 characters");
          isValid = false;
        } else {
          $("#passwordError").text("");
        }

        // Validate Confirm Password
        if (!confirmPassword) {
          $("#confirmPasswordError").text("Confirm your password");
          isValid = false;
        } else if (password !== confirmPassword) {
          $("#confirmPasswordError").text("Passwords do not match");
          isValid = false;
        } else {
          $("#confirmPasswordError").text("");
        }

        if (isValid) {
          handleRegister();
        }
      });
    });
  }, [username, email, password, confirmPassword]);

  const handleRegister = async () => {
    try {
      const { data } = await axios.post(`${BASE_URL}api/user/add`, { username, email, password });
      Swal.fire("Success", data.message, "success");
      navigate("/login");
    } catch (error) {
      console.error("Registration error:", error);
      let errorMessage = "An error occurred";
      if (error.response) {
        // Server responded with a status other than 200 range
        errorMessage = error.response.data?.message || "Server error";
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "No response from server";
      } else {
        // Something else happened while setting up the request
        errorMessage = error.message;
      }
      Swal.fire("Error", errorMessage, "error");
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="container d-flex justify-content-center align-items-center flex-grow-1">
        <div className="login-box p-4 shadow rounded bg-white" style={{ width: "100%", maxWidth: "400px" }}>
          <div className="text-center mb-4">
            <img
              src="https://res.cloudinary.com/softisans-com/image/upload/v1592236220/Logo/Softisans-Logo.png"
              alt="Softisans Logo"
              style={{ maxWidth: "180px", width: "60%", height: "auto" }}
            />
          </div>
          <h2 className="text-center">Register</h2>
          <p className="text-center text-muted">Create your account to get started</p>
          <form id="registerForm">
            <div className="form-group mb-3">
              <input
                type="text"
                placeholder="Username"
                className="form-control"
                onChange={(e) => setUserName(e.target.value)}
              />
              <small id="nameError" className="text-danger"></small>
            </div>
            <div className="form-group mb-3">
              <input
                type="email"
                placeholder="Email"
                className="form-control"
                onChange={(e) => setEmail(e.target.value)}
              />
              <small id="emailError" className="text-danger"></small>
            </div>
            <div className="form-group mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="form-control"
                onChange={(e) => setPassword(e.target.value)}
              />
              <small id="passwordError" className="text-danger"></small>
              <span
                className="position-absolute end-0 top-50 translate-middle-y me-2 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
            <div className="form-group mb-3 position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                className="form-control"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <small id="confirmPasswordError" className="text-danger"></small>
              <span
                className="position-absolute end-0 top-50 translate-middle-y me-2 cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{ cursor: "pointer" }}
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <button type="submit" className="btn btn-primary">
                Register
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/login")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* <footer className="bg-dark text-white text-center py-3 mt-auto">
        © {new Date().getFullYear()} rizWork. All rights reserved.
      </footer> */}
    </div>
  );
};

export default Register;
